import { useAuth } from "../auth/AuthContext";

export function useShortName() {
    const { user } = useAuth();
    
    // Obtenemos el nombre completo
    const rawName = user?.fullName || user?.username || "";
    let shortDisplayName = "Usuario"; // Valor por defecto

    if (rawName) {
        // Separamos el nombre por espacios
        const words = rawName.trim().split(/\s+/);
        
        if (words.length >= 5) {
            shortDisplayName = `${words[0]} ${words[1]} ${words[3]}`;
        } else if (words.length === 4) {
            shortDisplayName = `${words[0]} ${words[2]}`;
        } else if (words.length === 3) {
            shortDisplayName = `${words[0]} ${words[1]}`;
        } else {
            shortDisplayName = rawName;
        }
    }

    // El hook solo devuelve el nombre ya cortadito y listo para usar
    return shortDisplayName;
}